import React, { FC, memo, useEffect } from 'react'

import { useLocation } from 'react-router-dom'

import { getHomePage } from '@/actions/actions'
import { PageBackground } from '@/components/PageContent/PageBackground'
import { focusIds } from '@/constants/focus'
import { scrollOptions } from '@/constants/scrollers'
import { HomeTabPage } from '@/containers/HomeTabPage/HomeTabPage'
import { useFindNearestByImgWidth } from '@/hooks/useFindNearestByImgWidth'
import { usePageViewAnalytics } from '@/hooks/usePageViewAnalytics'
import useStore from '@/store/useStore'

const HomePageWithStageRaw: FC = () => {
  const { page, setPage } = useStore((state) => state.page)
  const { search } = useLocation()

  usePageViewAnalytics(page)

  useEffect(() => {
    getHomePage(search)
    return () => {
      setPage(null)
    }
  }, [])

  const pageBackgroundImg = useFindNearestByImgWidth(
    page?.backgroundImage?.sources,
    1920,
  )

  return (
    <>
      {pageBackgroundImg?.url && (
        <PageBackground src={pageBackgroundImg?.url} />
      )}
      {page?.homeTab?.length && (
        <HomeTabPage
          id={page.id}
          homeTab={page.homeTab}
          focusIdPrefix={focusIds.HOME}
          tabIndex={page.tabIndex}
          slideIndex={page.slideIndex}
          anchorId={page.anchorId}
          initFocusId={page.focusId}
          scrollOptions={scrollOptions.HomeScroll}
        />
      )}
    </>
  )
}

export const HomePageWithStage = memo(HomePageWithStageRaw)
